/**
 * Theme toggle button for switching between light, dark, and system modes.
 */
import { useUiStore, type Theme } from '@/stores/uiStore';

const THEME_ICONS: Record<Theme, string> = {
  light: '\u2600', // Sun
  dark: '\u263E',  // Moon
  system: '\u2699', // Gear
};

const THEME_LABELS: Record<Theme, string> = {
  light: 'Light mode',
  dark: 'Dark mode',
  system: 'System theme',
};

const THEME_CYCLE: Theme[] = ['light', 'dark', 'system'];

export const ThemeToggle = () => {
  const theme = useUiStore((state) => state.theme);
  const setTheme = useUiStore((state) => state.setTheme);

  const cycleTheme = () => {
    const currentIndex = THEME_CYCLE.indexOf(theme);
    const nextIndex = (currentIndex + 1) % THEME_CYCLE.length;
    setTheme(THEME_CYCLE[nextIndex]);
  };

  return (
    <button
      type="button"
      onClick={cycleTheme}
      className="flex h-9 w-9 items-center justify-center rounded-control border border-border bg-surface text-lg text-text-secondary transition hover:border-border-highlight hover:bg-surface-highlight hover:text-text-primary focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface"
      aria-label={THEME_LABELS[theme]}
      title={THEME_LABELS[theme]}
    >
      {THEME_ICONS[theme]}
    </button>
  );
};
